import type { ReactNode } from 'react';
import { cn } from './utils';

/**
 * Boolean-facet pill (plans/filter-standardization-spec.md §1), generalized
 * from ops's `toggleUnmatchedFilter` markup (`assets.tsx`). A checkbox reads
 * as a form input among selects; a pill reads as a filter — use this for
 * any boolean facet ("missing financials only", "unmatched only", etc.)
 * instead of a `<input type="checkbox">`.
 *
 * 44px tall to match the `.select`/`.input` control-height system in the
 * filter bar it's designed to sit inside — `items-end` rows stay a single
 * consistent height rather than mixing a 32px pill against 44px controls.
 */
export function ToggleChip({
  active,
  onClick,
  children,
  className,
}: {
  active: boolean;
  onClick: () => void;
  children: ReactNode;
  className?: string;
}) {
  return (
    <button
      type="button"
      onClick={onClick}
      aria-pressed={active}
      className={cn(
        'inline-flex h-11 shrink-0 items-center rounded-full border px-4 text-xs font-medium transition-colors',
        active
          ? 'border-primary bg-accent text-primary'
          : 'border-border bg-card text-muted-foreground hover:bg-muted',
        className,
      )}
    >
      {children}
    </button>
  );
}
